// components
import GridPageAbstract from '../../GridPageAbstract';
import { Money3BulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class CurrenciesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'currencies';
        this.Server = this.props.context.getState().server.currencies;
        this.hideSearch = false;
        this.headerStartIcon = Money3BulkIcon;

        this.searchFields = ['name', 'shortName'];

        this.hiddenColumns = config?.hiddenColumns?.currencies || [];

        this.Head = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'shortName',
                label: 'shortName',
                alignRight: false,
                cell: 'Text'
            },
            { id: 'sign', label: 'sign', alignRight: false, cell: 'Text' },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
